/**
 * 右上ハンバーガーメニュー。
 *
 * - 投了 (during playing)
 * - 設定
 * - 部屋を出る (= disconnect + go home)
 *
 * クリック外しで閉じる。
 */

import { useEffect, useRef, useState } from 'react';
import { Icon } from './Icon';

export interface NavItem {
  label: string;
  onClick: () => void;
  variant?: 'default' | 'danger';
  testId?: string;
}

export function NavMenu({ items }: { items: NavItem[] }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    function onDoc(e: MouseEvent) {
      if (!ref.current) return;
      if (!ref.current.contains(e.target as Node)) setOpen(false);
    }
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') setOpen(false);
    }
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className="nav-menu" ref={ref}>
      <button
        className="nav-menu-trigger"
        aria-label="メニュー"
        aria-expanded={open}
        data-testid="nav-menu"
        onClick={() => setOpen((v) => !v)}
      >
        <Icon name="menu" />
      </button>
      {open && (
        <div className="nav-menu-panel" role="menu">
          {items.map((it, i) => (
            <button
              key={i}
              className={`nav-menu-item ${it.variant === 'danger' ? 'danger' : ''}`}
              role="menuitem"
              data-testid={it.testId}
              onClick={() => {
                setOpen(false);
                it.onClick();
              }}
            >
              {it.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
